import { render, staticRenderFns } from "./ChatterFeedEvent.vue?vue&type=template&id=39c93b68&scoped=true"
import script from "./ChatterFeedEvent.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatterFeedEvent.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ChatterFeedEvent.vue?vue&type=style&index=0&id=39c93b68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c93b68",
  null
  
)

export default component.exports